import { Footer } from "../../components/Footer/Footer"
import { Header } from "../../components/Header/Header"
import CyberArticle from "./CyberArticle/CyberArticle"

const CyberArticlePage = () => {
    return (
        <>
            <Header />
            <CyberArticle />
            <Footer /> 
        </>
    )
}

export default CyberArticlePage